import { Button } from "@mui/material";
import { FC, useCallback, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UcatLayout } from "../../.MODULS/UCAT_EXAM_MODUL/Components/Shared/UcatLayout";
import { SinglePageQuestion, SplitPane } from "../../.MODULS/UCAT_EXAM_MODUL/Components/Practice_Test/Exam_component";
import { AnswerType } from "../../.MODULS/UCAT_EXAM_MODUL/Components/sample data/Type";

interface UcatExamTemplateProps {
    previewData?: any;
    onBack?: () => void;
}

const UcatExamTemplate: FC<UcatExamTemplateProps> = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const rawQuestion = props.previewData || location.state;
    // Mock handlers since this is a preview/template
    const [selectedOptionIndex, setSelectedOptionIndex] = useState<number | null>(null);
    const [dragDropAnswers, setDragDropAnswers] = useState<Record<number, string | null>>({});

    const [writingAnswer, setWritingAnswer] = useState<string>("");

    const handleOptionSelect = (index: number) => {
        setSelectedOptionIndex(index);
    };

    const handleDragDropChange = (itemId: number, bucketName: string | null, isExclusive?: boolean) => {
        setDragDropAnswers(prev => ({ ...prev, [itemId]: bucketName }));
    };

    const handleWritingChange = (value: string) => {
        setWritingAnswer(value);
    };

    // Normalize question logic reused from Practicetest.tsx
    const question = useMemo(() => {
        if (!rawQuestion) return null;

        const q = rawQuestion;
        let finalOptions = (q.options || []).map((opt: any) => ({
            ...opt,
            option_id: opt.option_id || opt.id || null,
            option_text: opt.option_text || opt.option || opt.answer || null,
            option_url: opt.option_url || opt.image_url || null,
        }));

        const derivedAnswerType = (() => {
            const type = String(q.answer_type || "").toUpperCase();
            if (type === "DRAG_DROP" || type === "DRAG-DROP") return AnswerType.DRAG_DROP;
            if (type === "TRUE_FALSE" || type === "TRUE-FALSE" || type === "YES_NO") return AnswerType.TRUE_FALSE;
            return AnswerType.MCQ;
        })();

        if (derivedAnswerType === AnswerType.TRUE_FALSE && (!finalOptions || finalOptions.length === 0)) {
            finalOptions = [
                { option_id: -1, option_text: "Yes", option_url: null },
                { option_id: -2, option_text: "No", option_url: null },
            ];
        }

        // Handle drag_drop_data from params.row
        let normalizedDragDropData = q.drag_drop_data;

        return {
            question_id: q.question_id || q.id,
            question_text: q.question_text || q.question || null,
            question_url: q.question_url || q.image_url || null,
            prompt: q.prompt || null,
            prompt_url: q.prompt_url || null,
            imgWidth: q.imgWidth || null,
            prompt_imgWidth: q.prompt_imgWidth || null,
            instruction: q.instruction || null,
            options: finalOptions,
            answer_type: derivedAnswerType,
            drag_drop_data: normalizedDragDropData || null,
            drag_drop_pattern: q.drag_drop_pattern || null,
            correctAnswerIndex: q.correctAnswerIndex,
            explanation: q.explanation,
            subtype_name: q.subType_name || q.subtype_name || "Preview",
            question_type_id: q.questionType || q.question_type_id || 0,
            question_type_name: q.Question_type_name || "Preview",
            source_type: q.source_type || "manual",
            subtype_id: q.subType || q.subtype_id || 0,
        };
    }, [rawQuestion]);

    if (!question) {
        return <div>No question data found.</div>;
    }

    // Determine if we show SplitPane (if prompt exists) or SinglePageQuestion
    const hasPrompt = (question.prompt && question.prompt.trim() !== "" && question.prompt !== "<p><br></p>") || !!question.prompt_url;
    const ContentComponent = hasPrompt ? SplitPane : SinglePageQuestion;

    return (
        <UcatLayout
            headerTitle="Question Preview"
            headerSubtitle={question.subtype_name}
            showToolbar={true}
            headerRightActions={
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        if (props.onBack) {
                            props.onBack();
                        } else {
                            navigate(-1);
                        }
                    }}
                    size="small"
                >
                    Back
                </Button>
            }
        >
            <ContentComponent
                question={question}
                selectedOptionIndex={selectedOptionIndex}
                dragDropAnswers={dragDropAnswers}
                writingAnswer={writingAnswer}
                onOptionSelect={handleOptionSelect}
                onDragDropChange={handleDragDropChange}
                onWritingChange={handleWritingChange}
                isReviewMode={false}
                // left={true} // Mock scroll status
                // right={true}
                onScrollStatusChange={() => { }}
                passage={question.prompt}
                promptUrl={question.prompt_url}
            />

        </UcatLayout>
    );
};

export default UcatExamTemplate;
